export const translationNavigation_sv_part3 = {
  currentProfilePicture: "Nuvarande profilbild",
  profilePictureDescription: "Den här bilden visas bredvid dina meddelanden i chatten",
  uploadNewProfilePicture: "Ladda upp ny profilbild",
  chooseFile: "Välj fil",
  uploading: "Laddar upp...",
  supportedFormats: "Format som stöds: JPEG, PNG, GIF, WebP. Max storlek: 5 MB",
  saving: "Sparar...",
  profilePictureUpdatedSuccess: "Profilbilden uppdaterades!",
  errorUploadingProfilePicture: "Fel vid uppladdning av profilbild. Försök igen.",
  invalidFileType: "Välj en giltig bildfil (JPEG, PNG, GIF eller WebP)",
  fileSizeError: "Filstorleken måste vara mindre än 5 MB",
  notificationSettings: "Notifieringsinställningar",
  emailNotificationsLabel: "E-postnotifieringar",
  emailWhenTagged: "Skicka e-post till mig när jag taggas i en rapport",
  livechatNotificationsLabel: "Livechat-notifieringar",
  livechatPopupSetting: "Visa en popup när det finns ny livechat-aktivitet",
  livechatOtherAgentsSetting: "Meddela mig om chattar som hanteras av andra agenter",
  notificationSoundTitle: "Notifieringsljud",
  notificationSoundDescription: "Spela upp ett ljud när du tar emot nya livechat-meddelanden",
  testNotificationSound: "Testa ljud",
  testSoundEnabled: "Klicka för att testa notifieringsljudet",
  testSoundDisabled: "Aktivera ljudnotifieringar för att testa",
  userProfilePicturesTitle: "Användares profilbilder",
  showUserProfilePicturesTitle: "Visa användares profilbilder",
  showUserProfilePicturesDescription:
    "Visa djuravatar-profilbilder för användare i livechat-konversationer för att hjälpa till att identifiera och komma ihåg användare",

  // User edit chatbot editor — tab bar

  // User edit chatbot editor — tab bar
  userEditTabPreview: "Förhandsvisning",
  userEditTabBasic: "Grundinställningar",
  userEditTabProducts: "Produkter",
  userEditTabExtra: "Extra inställningar",
  userEditTabMain: "Huvudflöde",
  userEditTabRouting: "Fördelningsflöde",
  userEditTabStatistics: "Statistikflöde",
  userEditTabSuggestion: "Förlagsflöde",
  userEditTabApivar: "API-var flöde",
  userEditTabMetaPrefix: "Meta: ",
  userEditTabDomainRestrictions: "Domänbegränsningar",
  userEditTabImage: "Bildflöde",
  userEditTabShopify: "Shopify",
  userEditTabMagento: "Magento",
  userEditTabShipmondo: "Shipmondo",
  userEditTabCommerceTools: "CommerceTools",
  userEditTabUniversalApiPlanner: "Universal API Planner",
  userEditTabUniversalApi: "Universal API Integration",
  userEditUniversalApiPlannerStepLimitsTitle: "Planner-steg (minimum / maximum)",
  userEditUniversalApiPlannerStepLimitsHint:
    'Minimum är hur många planner-rundor som måste köras innan ett "finish"-beslut beaktas. Maximum begränsar planner-anrop per meddelande (1–10). Spara gränser separat från integrationsbehörigheter.',
  userEditUniversalApiPlannerMinSteps: "Minimumsteg",
  userEditUniversalApiPlannerMaxSteps: "Maximumsteg",
  userEditUniversalApiPlannerSaveStepLimits: "Spara planner-gränser",
  userEditUniversalApiPlannerSavingStepLimits: "Sparar…",

  userEditBasicSettingsSectionTitle: "Grundinställningar",
  userEditNoKnowledgeBaseIndexesHint:
    "Inga kunskapsbasindex konfigurerade. Lägg till dem i Grundinställningar.",
};
